export class ListDashboardsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListDashboardsFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortDashboardBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDashboardsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
